import { ButtonViewProfile } from './components/ButtonViewProfile';
import { ButtonContact } from './components/ButtonContact';
import { ButtonRequestQuote } from './components/ButtonRequestQuote';
import { LastMessageContainer } from './components/LastMessageContainer';
import { Quote } from './components/Quote';
import { LabelRow } from './components/LabelRow';
import { CompanyName } from './components/CompanyName';
import { CategoryBullets } from './components/CategoryBullets';
import { Avatar } from './components/Avatar';
import { ReviewsAndDistance } from './components/ReviewsAndDistance';
import { Distance } from './components/Distance';
import { CategoryPills } from './components/CategoryPills';
import { Description } from './components/Description';
import { ViewProfileAndLabels } from './components/ViewProfileAndLabels';
import { CompanyNameAndReviews } from './components/CompanyNameAndReviews';
import { ButtonCall } from './components/ButtonCall';
import { ReadyToCall } from './components/ReadyToCall';
import { EnquiriesFeedback } from './components/EnquiriesFeedback';
import { ButtonCallback } from './components/ButtonCallback';
import { Booking } from './components/Booking';
import { MarketplaceEnquiriesFeedback } from './components/MarketplaceEnquiriesFeedback';
import {
	separationListMobileButtons,
	separationListTabletButtons,
	separationListDesktopButtons,
} from '../../experiments/enquiries-sellers-separation/enquiries-sellers-only-list-buttons';

export class CardTypeContainers {
	constructor(cardType, experiments) {
		this.cardType = cardType;
		this.experiments = experiments;
		this.separationListCtasExp = this.experiments?.find(
			(x) => x.name === 'separation_list_ctas',
		);
		this.isMarketplaceSeparatedList =
			this.separationListCtasExp?.isMarketplaceSeparatedList ?? false;
		this.mobileContainer = this.buildMobileContainers(cardType);
		this.tabletContainer = this.buildTabletContainers(cardType);
		this.desktopContainer = this.buildDesktopContainers(cardType);
	}

	buildMobileContainers = (cardType) => {
		if (cardType === 'primary') {
			const book_now_buttons = [
				new ButtonCallback(
					'button-callback',
					{ dynamicClasses: 'w-100 mb-0 mb-2', isMobile: true },
					this.experiments,
				),
				new ButtonCall(
					'button-call',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						dynamicClasses: 'w-100 btn-lg',
						wrapperClasses: 'col-6 pr-2 ',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonViewProfile(
					'button-view-profile',
					{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: 'col-6  ', isMobile: true },
					this.experiments,
				),
				new EnquiriesFeedback(
					'enquiries-feedback',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new Booking(
					'bookings',
					{
						dynamicClasses: 'w-100 mb-0',
						isMobile: true,
					},
					this.experiments,
				),
			];
			let marketplace_both = [
				new ButtonCallback(
					'button-callback',
					{
						dynamicClasses: 'w-100',
						isMobile: true,
					},
					this.experiments,
				),
				new MarketplaceEnquiriesFeedback(
					'marketplace-feedback',
					{ dynamicClasses: 'w-100', isMobile: true },
					this.experiments,
				),
				new ButtonCall(
					'button-call',
					{
						dynamicClasses: 'w-100',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						dynamicClasses: 'w-100',
						button_classes: 'py-3',
						isMobile: true,
					},
					this.experiments,
				),
			];

			if (this.isMarketplaceSeparatedList) {
				marketplace_both = separationListMobileButtons(this.experiments);
			}

			let enquiry_buttons = [
				new ButtonCall(
					'button-call',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new ButtonViewProfile(
					'button-view-profile',
					{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: 'col-6  ', isMobile: true },
					this.experiments,
				),
				new EnquiriesFeedback(
					'enquiries-feedback',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						dynamicClasses: 'w-100 btn-lg',
						wrapperClasses: 'col-6 pr-2 ',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{ dynamicClasses: 'w-100 mb-0 mb-2', isMobile: true },
					this.experiments,
				),
			];

			let buttons = [
				new ButtonViewProfile(
					'button-view-profile',
					{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: ' ', isMobile: true },
					this.experiments,
				),
				new ButtonCall(
					'button-call',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new EnquiriesFeedback(
					'enquiries-feedback',
					{ dynamicClasses: 'w-100 mb-0', isMobile: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: ' ', isMobile: true },
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{ dynamicClasses: 'w-100', isMobile: true },
					this.experiments,
				),
			];

			return {
				north: [
					new Avatar('avatar', { includeEliteProMobile: true }, this.experiments),
					new ReviewsAndDistance(
						'reviews-and-distance',
						{ isMobile: true },
						this.experiments,
					),
				],
				center: [
					new CompanyName('company-name', {}, this.experiments),
					new LabelRow('label-row', {}, this.experiments),
					new Description('description', { isMobile: true }, this.experiments),
					new CategoryBullets('category-bullets', { isMobile: true }, this.experiments),
				],
				interactions: [
					new Quote(
						'quote',
						{ dynamicClasses: 'text-lg align-self-end mb-0', divider: true },
						this.experiments,
					),
					new LastMessageContainer('last-message-container', {}, this.experiments),
					new Booking(
						'bookings',
						{
							dynamicClasses: 'w-100 mt-3',
							wrapperClasses: 'col-12',
							isMobile: true,
						},
						this.experiments,
					),
				],
				enquiry_buttons,
				book_now_buttons,
				marketplace_both,
				buttons,
			};
		} else if (cardType === 'bookable') {
			return {
				north: [
					new Avatar('avatar', { includeEliteProMobile: true }, this.experiments),
					new ReviewsAndDistance(
						'reviews-and-distance',
						{ isMobile: true },
						this.experiments,
					),
				],
				center: [
					new CompanyName('company-name', {}, this.experiments),
					new LabelRow('label-row', {}, this.experiments),
					new Description('description', { isMobile: false }, this.experiments),
				],
				interactions: [],
				enquiry_buttons: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: ' ', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-0 mb-2', isMobile: true },
						this.experiments,
					),
				],
				book_now_buttons: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 btn-lg', wrapperClasses: ' ', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-0 mb-2', isMobile: true },
						this.experiments,
					),
				],
				marketplace_both: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 mb-1', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-0 mb-1', isMobile: true },
						this.experiments,
					),
				],
				buttons: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 mb-1', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-1', isMobile: true },
						this.experiments,
					),
				],
			};
		}
		return { north: [], center: [], interactions: [], buttons: [] };
	};

	buildTabletContainers = (cardType) => {
		if (cardType === 'primary') {
			const buttons = [
				new ButtonCall(
					'button-call',
					{
						dynamicClasses: 'w-100',
						wrapperClasses: 'cta-mw-160 ml-auto',
						isTablet: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'button-callback',
					{
						dynamicClasses: 'w-100',
						wrapperClasses: 'cta-mw-160 ml-2',
						isTablet: true,
					},
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						wrapperClasses: 'cta-mw-160 ml-2',
						dynamicClasses: 'w-100',
						isTablet: true,
					},
					this.experiments,
				),
				new Booking(
					'bookings',
					{
						dynamicClasses: 'w-100 mt-3',
						wrapperClasses: 'col-12',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{
						dynamicClasses: 'w-100',
						wrapperClasses: 'cta-mw-160 ml-2',
						isTablet: true,
					},
					this.experiments,
				),
			];
			let marketplace_both = [
				new Booking(
					'bookings',
					{
						dynamicClasses: 'w-100 mt-3',
						wrapperClasses: 'col-12',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonCall(
					'button-call',
					{
						dynamicClasses: 'w-100',
						wrapperClasses: 'cta-mw-160 ml-auto',
						isTablet: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'button-callback',
					{ dynamicClasses: 'w-100', wrapperClasses: 'cta-mw-160 ml-2', isTablet: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						dynamicClasses: 'w-100',
						wrapperClasses: 'cta-mw-160 ml-2',
						isTablet: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{ dynamicClasses: 'w-100 mb-2', isMobile: true },
					this.experiments,
				),
			];

			if (this.isMarketplaceSeparatedList) {
				marketplace_both = separationListTabletButtons(this.experiments);
			}

			return {
				west: [new Avatar('avatar', {}, this.experiments)],
				core: [
					new CompanyNameAndReviews('company-name-and-reviews', {}, this.experiments),
					new Distance('distance', {}, this.experiments),
					new CategoryPills(
						'category-pills',
						{
							wrapperClasses: 'd-flex flex-row align-items-center justify-content-start',
						},
						this.experiments,
					),
					new Description('description', {}, this.experiments),
					new Quote(
						'quote',
						{
							wrapperClasses: 'd-flex text-right align-self-end',
							dynamicClasses: 'mb-2 text-lg ml-auto',
							divider: true,
						},
						this.experiments,
					),
					new LastMessageContainer(
						'last-message-container',
						{ mobile: false },
						this.experiments,
					),
					new ViewProfileAndLabels(
						'view-profile-and-labels',
						{ wrapperClasses: 'ml-auto' },
						this.experiments,
					),
					new EnquiriesFeedback(
						'enquiries-feedback',
						{ dynamicClasses: 'w-100 mt-4 mb-0' },
						this.experiments,
					),
					new MarketplaceEnquiriesFeedback(
						'marketplace-feedback',
						{ dynamicClasses: 'w-100 mt-4 mb-0' },
						this.experiments,
					),
				],
				buttons,
				marketplace_both,
			};
		} else if (cardType === 'bookable') {
			return {
				west: [new Avatar('avatar', {}, this.experiments)],
				core: [
					new CompanyNameAndReviews('company-name-and-reviews', {}, this.experiments),
					new Distance('distance', {}, this.experiments),
					new CategoryPills(
						'category-pills',
						{
							wrapperClasses: 'd-flex flex-row align-items-center justify-content-start',
						},
						this.experiments,
					),
					new Description('description', {}, this.experiments),
					new Quote(
						'quote',
						{
							wrapperClasses: 'd-flex text-right align-self-end',
							dynamicClasses: 'mb-2 text-lg ml-auto',
							divider: true,
						},
						this.experiments,
					),
					new LastMessageContainer(
						'last-message-container',
						{ mobile: false },
						this.experiments,
					),
					new ViewProfileAndLabels(
						'view-profile-and-labels',
						{ wrapperClasses: 'ml-auto' },
						this.experiments,
					),
					new EnquiriesFeedback(
						'enquiries-feedback',
						{ dynamicClasses: 'w-100 mt-4 mb-0' },
						this.experiments,
					),
					new MarketplaceEnquiriesFeedback(
						'marketplace-feedback',
						{ dynamicClasses: 'w-100 mt-4 mb-0' },
						this.experiments,
					),
				],
				buttons: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 mb-2 mr-3', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-2', isMobile: true },
						this.experiments,
					),
				],
				marketplace_both: [
					new ButtonViewProfile(
						'transactions-view-profile',
						{ dynamicClasses: 'w-100 mb-2 mr-3', isMobile: true },
						this.experiments,
					),
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mb-2', isMobile: true },
						this.experiments,
					),
				],
			};
		}
		return { west: [], core: [], buttons: [] };
	};

	buildDesktopContainers = (cardType) => {
		if (cardType === 'primary') {
			const buttons = [
				new Quote(
					'quote',
					{ dynamicClasses: 'text-xl mb-auto align-self-end' },
					this.experiments,
				),
				new EnquiriesFeedback(
					'enquiries-feedback',
					{ isDesktop: true },
					this.experiments,
				),
				new ButtonCall(
					'button-call',
					{ dynamicClasses: 'w-100 mt-2', isDesktop: true },
					this.experiments,
				),
				new ButtonCallback(
					'button-callback',
					{ dynamicClasses: 'w-100 mt-2', isDesktop: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{ dynamicClasses: 'w-100', isDesktop: true },
					this.experiments,
				),
				new Booking(
					'bookings',
					{
						dynamicClasses: 'w-100 mt-3',
						wrapperClasses: 'col-12',
						isMobile: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{ dynamicClasses: 'w-100 mt-0', isMobile: true },
					this.experiments,
				),
			];
			let marketplace_both = [
				new ButtonCall(
					'button-call',
					{ dynamicClasses: 'w-100', isDesktop: true },
					this.experiments,
				),
				new ButtonCallback(
					'button-callback',
					{ dynamicClasses: 'w-100', isDesktop: true },
					this.experiments,
				),
				new ButtonRequestQuote(
					'button-request-quote',
					{
						dynamicClasses: 'w-100',
						button_classes: 'py-3',
						isDesktop: true,
					},
					this.experiments,
				),
				new MarketplaceEnquiriesFeedback(
					'marketplace-feedback',
					{ isDesktop: true },
					this.experiments,
				),
				new Booking(
					'bookings',
					{
						dynamicClasses: 'w-100',
						isDesktop: true,
					},
					this.experiments,
				),
				new ButtonCallback(
					'booking_request-book-now',
					{ dynamicClasses: 'w-100 mt-0', isMobile: true },
					this.experiments,
				),
			];

			if (this.isMarketplaceSeparatedList) {
				marketplace_both = separationListDesktopButtons(this.experiments);
			}

			return {
				west: [new Avatar('avatar', {}, this.experiments)],
				core: [
					new CompanyNameAndReviews('company-name-and-reviews', {}, this.experiments),
					new Distance('distance', {}, this.experiments),
					new CategoryPills(
						'category-pills',
						{
							wrapperClasses: 'd-flex flex-row align-items-center justify-content-start',
						},
						this.experiments,
					),
					new Description('description', {}, this.experiments),
					new LastMessageContainer(
						'last-message-container',
						{ mobile: false },
						this.experiments,
					),
					new ViewProfileAndLabels('view-profile-and-labels', {}, this.experiments),
				],
				buttons,
				marketplace_both,
			};
		} else if (cardType === 'bookable') {
			return {
				west: [new Avatar('avatar', {}, this.experiments)],
				core: [
					new CompanyNameAndReviews('company-name-and-reviews', {}, this.experiments),
					new Distance('distance', {}, this.experiments),
					new CategoryPills(
						'category-pills',
						{
							wrapperClasses: 'd-flex flex-row align-items-center justify-content-start',
						},
						this.experiments,
					),
					new Description('description', {}, this.experiments),
					new LastMessageContainer(
						'last-message-container',
						{ mobile: false },
						this.experiments,
					),
					new ViewProfileAndLabels('view-profile-and-labels', {}, this.experiments),
				],
				buttons: [
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mt-0', isMobile: true },
						this.experiments,
					),
				],
				marketplace_both: [
					new ButtonCallback(
						'transactions-book-now',
						{ dynamicClasses: 'w-100 mt-0', isMobile: true },
						this.experiments,
					),
				],
			};
		}
		return { west: [], core: [], buttons: [] };
	};

	buildTemplateArgs = (templateData) => {
		if (this.cardType === 'legacy') {
			return {};
		}
		const outputCard = {
			mobileContainer: {},
			tabletContainer: {},
			desktopContainer: {},
		};
		Object.keys(outputCard).map((containerName, index) => {
			Object.keys(this[containerName]).map((value, index) => {
				outputCard[containerName][value] = this[containerName][value].reduce(
					(htmlContent, cardComponent) => {
						return (
							htmlContent +
							'\n ' +
							cardComponent.createHtml({
								...templateData,
								mobile: containerName === 'mobileContainer',
							})
						);
					},
					'',
				);
			});
		});
		return outputCard;
	};
}
